import { Component, OnInit, Input } from '@angular/core';
import { FormElementSocialMedia } from '../shared/model/social-media/form-element-social-media.model';

@Component({
  selector: 'wl-form-builder-social-media-display-element',
  templateUrl: 'form-builder-social-media-display-element.component.html',
    standalone: false
})
export class FormBuilderSocialMediaDisplayElementComponent {
  @Input('socialMediaSettings') socialMediaSettings: FormElementSocialMedia;

  public constructor() {
    this.socialMediaSettings = new FormElementSocialMedia();
  }

  ngOnInit(): void {}
}
